import { UPDATE_POLLING_STATS } from 'constants/actionTypes';

const initState = {
    error: false,
    fetching: false,
    ttl: undefined,
    ttlEnd: false,
    inProgress: false,
    lastResponseStatus: null,
    nextPollEta: null,
    ok: true,
    isLastRequest: false,
    retriesAfterFailure: 0,
    shouldContinue: true,
    counter: 0,
};

const polling = (state = initState, action) => {
    switch (action.type) {
        case UPDATE_POLLING_STATS:
            return { ...state, ...action.stats };
        default:
            return state;
    }
};

export { polling as default, initState };
